/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.Events.Timer <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 27.1.2021<br />
/// Copyright ©: EUDT GmbH 2021 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 27.1.2021                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.EventTimer", $.common.VisualBase, {
  
    _create: function () {
        var me = this;

        try {

            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 310;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));

            //inits the super class
            me._super();
           
        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        this.showMessage("", false);
    },

    _initEvents: function () {
        var me = this;
        try {
          //

        //init the save button
            me.element.on("click", " #btn-save", function () { me._save() });
            me.fnd("#btn-save").button();
            me.fnd(" #btn-save").button("option", "disabled", true);


           
            if (me.specific.eventType === 2) {
                //init the simple clock timer for archive alarms
                me.fnd("#btn-save").css("margin-right", "62px");
                me.fnd("#div-timer").vcClockTimer({ callback: function() {
                    me.fnd(" #btn-save").button("option", "disabled", false);
                }});
                me.fnd(".clocktimer").css('background-color', "#fff").css("border", "18px solid #fff");

               
            } else {
                //initthe new one for the hr alarm and emax
                me.fnd("#btn-save").css("margin-right", "7px");
                var cf = JSON.parse(me.specific.calendarFilter);

                if (typeof cf.ID != "undefined") {
                    cf.ID = "div-timer";
                }
                var options = {}
                options.data = cf;
               
                options.langID = me.settings.userLangIDForCulture;
                options.callback = function () {
                    me.fnd(" #btn-save").button("option", "disabled", false);
                }

                me.fnd("#div-timer").vcCalendarFilter(options);
                me.fnd("#div-timer .navigation").hide();

            }

        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },



    _save: function () {
        /// <summary>
        /// This function sends the update request - quite simple
        /// </summary>
        var me = this;
        var param;
       
        try {

            if (me.specific.eventType === 2) {
                param = me.fnd("#div-timer").html();
            } else {
                param = me.fnd("#div-timer").vcCalendarFilter("getData");
            }
          
            me.updateData( param, function (result) {

                if (result === true) {
                    me.fnd(" #btn-save").button("option", "disabled", true);
                    _VCMQ.produce(me.visual, me.vcgid, 'EVENT_CONFIG_DIRTY', "");
                } else {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                return true;
            });

            return true;
        } catch (e) {
            me.writeError('_save', e); return false;
        }

    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd("#div-timer, #btn-save").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }


});
